<template>
  <v-layout align-center justify-center row fill-height>
    <div class="login">
      <v-form v-model="formValid" ref="formLogin" lazy-validation>
        <v-card class="mb-2" height="300">
          <v-card-title>
            <v-img :src="urlImageLogo" aspect-ratio="2" contain height="70px"></v-img>
          </v-card-title>
          <v-card-text class="py-4">
            <v-text-field v-model="email" required :rules="rules.email" label="Correo" outline color="#0D47A1"></v-text-field>
            <v-text-field v-model="password" required :rules="rules.password" label="Contraseña" outline type="password" color="#0D47A1"></v-text-field>
          </v-card-text>
        </v-card>

        <v-layout>
          <v-spacer></v-spacer>
          <v-btn color="#0D47A1" dark @click="login">Conectarse</v-btn>
        </v-layout>
      </v-form>
    </div>
  </v-layout>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'login',
  
  data() {
    return {
      formValid: true,
      srcImageLogo: null,
      rules: {
        email: [
          v => !!v || 'El campo email es requerido para conectarse',
          v => /.+@.+/.test(v) || 'El email ingresado no es valido'
        ],
        password: [v => !!v || 'El campo contraseña es requerido para conectarse']
      },
      email: '',
      password: ''
    }
  },

  methods: {
    login: function() {
      if(this.$refs.formLogin.validate()) {
        firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
          (user) => { 
            this.$router.replace('home')
          },
          (err) => { alert('Oops. ' + err.message) }
        );
      }
    }
  },

  computed: {
    urlImageLogo () {
      return require('../assets/logo.jpg')
    }
  },
}
</script>

<style>
.login {
  width: 380px;
}
</style>


